import { FC } from 'react';

import { useGate } from '../../../../hooks/use-gate';
import { useTranslations } from '../../../../hooks/use-translations';

import { SelectForm, SelectFormProps } from './SelectForm';

type GateSelectFormProps = Omit<SelectFormProps<string>, 'options'> & {
  withEmpty?: boolean;
  gateType?: 'invoice' | 'withdraw';
  gateCurrency?: string;
};

export const GateSelectForm: FC<GateSelectFormProps> = (props) => {
  const { placeholder, withEmpty, gateType, gateCurrency, ...selectProps } = props;

  const { loading, data } = useGate({ gateType, gateCurrency });

  const tMisc = useTranslations('misc');
  const t = useTranslations('dictionaries.gate');

  return (
    <SelectForm
      {...selectProps}
      displayType="name-small-value-if-name"
      placeholder={loading ? tMisc('loading') : placeholder}
      renderValue={(selected) => {
        if (!selected) {
          return t('all');
        }

        return data?.v_active_gate.find(({ id }) => id === selected)?.alias || selected;
      }}
      options={
        data
          ? [
              ...(withEmpty ? [{ value: '', name: t('all') }] : []),
              ...data.v_active_gate.map((gate) => ({ value: gate.id ?? '', name: gate.alias || null })),
            ]
          : []
      }
      disabled={loading}
    />
  );
};
